import React from 'react';
import { Link, browserHistory } from 'react-router';
import { Button } from '@blueprintjs/core';
import { User } from 'api';
import { connect } from 'react-redux';
import cookie from 'react-cookie';
import { checkServerLive } from 'constants/config';
import { ShowIf } from 'components/utils';
import { Toastr } from 'modules/toastr';
import { msg } from "constants/message";
import { checkEmail } from 'base/lib/validate';

let loginBg = require('assets/images/bannerLogin.png');
class ForgotPassword extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      Username: '',
      loading: false,
      isSubmit: false,
      emailValid: true
    }
  }

  componentDidMount() {
    if (typeof cookie.load('accessToken') != 'undefined') {
      browserHistory.push('/');
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      isSubmit: false,
      emailValid: true
    });
  }

  handleForgotPassword(e) {
    e.preventDefault();
    if (this.handleValidate()) {
      let params = {
        email: this.state.Username,
      }
      this.setState({ loading: true });
      User.actions.sendCode.request(null, params).then(res => {
        this.setState({ loading: false });
        Toastr('Gửi yêu cầu thành công. Vui lòng kiểm tra hộp thư điện tử để lấy lại mật khẩu.', 'success');
      }).catch((error) => {
        this.setState({ loading: false });
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }

  handleValidate() {
    this.setState({ isSubmit: true });
    let pass = true;
    if (!this.state.Username) {
      pass = false;
    } else if (!checkEmail(this.state.Username)) {
      pass = false;
      this.setState({ emailValid: false });
    }
    return pass;
  }

  render() {
    let logoImg = require('assets/images/logo-login.png');
    return (
      <div className="login" style={{ backgroundImage: `url(${loginBg})` }}>
        <div className="login-block">
          <h1 className="logo-login">
            <img src={logoImg} alt="" className="login-logo-image" />
            <span className="login-logo-caption">Phần mềm và xây dựng cơ sở dữ liệu hoạt động thanh tra trên địa bàn Tỉnh Quảng Ngãi</span>
          </h1>
          <form className="login-form" onSubmit={this.handleForgotPassword.bind(this)} noValidate>
            <h2 className="title-login txt-blue">Quên mật khẩu</h2>
            <div className="login-group sub-title-login">
              Vui lòng nhập địa chỉ thư điện tử vào ô bên dưới để nhận được giúp đỡ
            </div>
            <div className="login-group">
              <span className="tt-login-mail"></span>
              <input className={`login-input pt-input ${this.state.isSubmit && !this.state.Username ? 'pt-intent-danger' : ''}`}
                type="text" placeholder="Địa chỉ thư điện tử" name="Username" value={this.state.Username}
                onChange={this.handleChange.bind(this)} autoFocus autoComplete="off"
                maxLength={40} />
              {
                this.state.isSubmit && !this.state.Username ?
                  <div className="pt-form-helper-text">{msg.messageDefault}</div>
                  : null
              }
              {
                this.state.isSubmit && !this.state.emailValid ?
                  <div className="pt-form-helper-text">{msg.emailInvalid}</div>
                  : null
              }
            </div>
            <div className="login-group">
              <Button type="submit" className={`btn-login ${this.state.loading ? 'btn-loading-inline' : ''}`} text="Gửi yêu cầu" />
            </div>
            <div className="login-group">
              <p className='txt-center'>
                <Link to="/dang-nhap" className="text-14 txt-blue">Đăng nhập</Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect()(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/modules/forgot-password/ForgotPassword.jsx